module.exports = __webpack_public_path__ + "static/media/savingAmountTV.4cf76fac.png";